import React from "react";
import classNames from "classnames/bind";
import { ChevronLeft, ChevronRight } from "lucide-react";
import styles from "../ProfilePage.module.scss";

const cx = classNames.bind(styles);

const Pagination = ({ 
  currentPage, 
  totalPages, 
  onPageChange, 
  isLoading 
}) => {
  if (totalPages <= 1) return null;

  const getPageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 5;
    
    if (totalPages <= maxVisiblePages) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= 3) {
        for (let i = 1; i <= 4; i++) {
          pages.push(i);
        }
        pages.push('...');
        pages.push(totalPages);
      } else if (currentPage >= totalPages - 2) {
        pages.push(1);
        pages.push('...');
        for (let i = totalPages - 3; i <= totalPages; i++) {
          pages.push(i);
        }
      } else {
        pages.push(1);
        pages.push('...');
        for (let i = currentPage - 1; i <= currentPage + 1; i++) {
          pages.push(i);
        }
        pages.push('...');
        pages.push(totalPages);
      }
    }
    
    return pages;
  };

  const pageNumbers = getPageNumbers();

  return (
    <div className={cx("pagination")}>
      <div className={cx("pagination-info")}>
        Trang {currentPage} / {totalPages}
      </div>
      
      <div className={cx("pagination-controls")}>
        <button
          className={cx("pagination-btn", "prev")}
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1 || isLoading}
        >
          <ChevronLeft size={16} />
          Trước
        </button>

        <div className={cx("pagination-numbers")}>
          {pageNumbers.map((page, index) => (
            <React.Fragment key={index}>
              {page === '...' ? (
                <span className={cx("pagination-ellipsis")}>...</span>
              ) : (
                <button
                  className={cx("pagination-number", {
                    active: page === currentPage
                  })}
                  onClick={() => onPageChange(page)}
                  disabled={isLoading}
                >
                  {page}
                </button>
              )}
            </React.Fragment>
          ))}
        </div>

        <button
          className={cx("pagination-btn", "next")}
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages || isLoading}
        >
          Sau
          <ChevronRight size={16} />
        </button>
      </div>
    </div>
  );
};

export default Pagination;
